// A deterministic generated cover: the name's initial on a name-seeded
// gradient. Used wherever real imagery does not exist yet (dashboard cards,
// play landings without key art) so empty slots read as intentional.
import type { CSSProperties } from 'react';

export function GeneratedCover({ name, fontSize = 34, style }: {
  name: string;
  fontSize?: number;
  style?: CSSProperties;
}) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  const hue = hash % 360;
  const initial = (name.trim()[0] ?? '?').toUpperCase();
  return (
    <div aria-hidden="true" style={{
      width: '100%', height: 150, borderRadius: 10, pointerEvents: 'none',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: `linear-gradient(135deg, hsl(${hue}, var(--ss-cover-sat-1), var(--ss-cover-l-1)), hsl(${(hue + 40) % 360}, var(--ss-cover-sat-2), var(--ss-cover-l-2)))`,
      border: '1px solid var(--ss-border-soft)',
      ...style,
    }}>
      <span style={{ fontFamily: 'var(--ss-display)', fontSize, fontWeight: 500, color: `hsl(${hue}, var(--ss-cover-ink-sat), var(--ss-cover-ink-l))`, opacity: 0.9 }}>{initial}</span>
    </div>
  );
}
